export const ACTION_TYPES = {
  LOGIN: "user/LOGIN",
  LOGIN_TVE: "user/LOGIN_TVE",
  REQUEST: "user/LOGIN_REQUEST",
  SUCCESS: "user/LOGIN_SUCCESS",
  FAILURE: "user/LOGIN_FAILURE",
  RESET: "user/RESET_USER",
  SET_USER: "user/SET_USER",
  UPDATE_USER: "user/UPDATE_USER",
  UPDATE_INFO_USER: "user/UPDATE_INFO_USER",
  GET_USER_PREFERENCES: "user/GET_USER_PREFERENCES",
  LOGOUT: "user/LOGOUT"
};

export const login = (userName, password, redirectTo) => ({
  type: ACTION_TYPES.LOGIN,
  payload: { userName, password, redirectTo }
});

export const loginTVE = (userName, password) => ({
  type: ACTION_TYPES.LOGIN_TVE,
  payload: { userName, password }
});

export const loginRequest = () => {
  return { type: ACTION_TYPES.REQUEST };
};

export const loginSuccess = () => ({
  type: ACTION_TYPES.SUCCESS
});

export const loginFailure = (error) => ({
  type: ACTION_TYPES.FAILURE,
  payload: { ...error }
});

export const resetUser = () => ({
  type: ACTION_TYPES.RESET
});

export const setUser = (user) => ({
  type: ACTION_TYPES.SET_USER,
  payload: { ...user }
});

export const updateUser = (property, value) => ({
  type: ACTION_TYPES.UPDATE_USER,
  payload: { property, value }
});

export const updateInfoUser = (infoToChange, property, value) => {
  return {
    type: ACTION_TYPES.UPDATE_INFO_USER,
    payload: { infoToChange, property, value }
  };
};

export const getUserPreferences = () => {
  return { type: ACTION_TYPES.GET_USER_PREFERENCES };
};

export const logout = () => ({
  type: ACTION_TYPES.LOGOUT
});
